import { Box, Divider, Typography, useTheme } from '@mui/material';
import NavButtons from '../NavButtons/NavButtons';

/**
 * The properties for the footer
 */
interface FooterProps {
  /**
   * Set to true to show the navigation in the footer. False will hide
   * it and center the copy-write notice
   */
  showNav: boolean;
}

/**
 * The footer for the website
 */
const Footer = (props: FooterProps) => {
  const theme = useTheme();

  return (
    <>
      <Divider />
      <footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '2em',
          padding: '.5em',
        }}
      >
        {props.showNav && (
          <Box
            sx={{
              display: {
                xs: 'none',
                md: 'initial',
              },
            }}
          >
            <NavButtons withPrivacyAndTerms />
          </Box>
        )}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
          sx={{
            width: {
              md: props.showNav ? 'initial' : '100%',
              xs: '100%',
            },
            marginBottom: {
              md: props.showNav ? 0 : '10px',
              xs: '10px',
            },
          }}
        >
          <Typography
            align="center"
            color={theme.palette.text.secondary}
            variant="subtitle2"
          >
            &copy; {new Date().getFullYear()}, Strategic Security Solutions
            Group LLC. All rights reserved.
          </Typography>
        </Box>
      </footer>
    </>
  );
};

export default Footer;
